module.exports = __webpack_public_path__ + "media/images/sp/plans/inclusion_40-f7bbe743334e1f5d5a3333452ded0b40.png";